import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        adjustments_history: {
          header: 'HEADER',
          download_report_button: 'DOWNLOAD_REPORT',
        },
      },
    },
  }));
}
